"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _utils = _interopRequireDefault(require("../../../../../../utils"));

var _RmName = _interopRequireDefault(require("../../../../../../RmName.json"));

var _reactCsv = require("react-csv");

var _icons = require("@ant-design/icons");

// import { useHistory } from 'react-router';
// import config from "config.json";
// import axios from 'axios';
// const { Option } = Select;
// var allTokens = [];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
var header = [{
  label: _RmName.default.nameCode,
  key: "RM_Code"
}, {
  label: "Student_Name",
  key: "Student_Name"
}, {
  label: "Reason",
  key: "Reason"
}, {
  label: "Want_to_Drop",
  key: "Want_to_Drop"
}, {
  label: "WhatsApp_Number",
  key: "WhatsApp_Number"
}, {
  label: "Date",
  key: "Date"
}, {
  label: "Token_Number",
  key: "Token_Number"
}, {
  label: "Reason",
  key: "Reason"
}, {
  label: "CL_Code",
  key: "CL_Code"
}];

var TableData = function TableData(_ref) {
  var data = _ref.data;

  // const history = useHistory();
  // const cl = localStorage.getItem("CL");
  // const token = localStorage.getItem("token");
  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1]; // const [apiError, setapiError] = useState(null);
  // const [visible, setVisible]= useState(false);


  var csvRport = {
    filename: "\"AllOldRequest Data\"+\" \"+".concat(today, "+\" \"+").concat(time),
    headers: header,
    data: data
  }; // useEffect(async()=>{
  //     setTableData(data);   
  // },[data]);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);
  var tableColumns = [{
    title: _RmName.default.nameCode,
    dataIndex: 'RM_Code',
    key: "RM_Code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_Code');
    }
  }, {
    title: "Student Name",
    dataIndex: 'Student_Name',
    key: 'Student_Name',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Student_Name');
    },
    render: function render(_, record) {
      return record.Student_Name ? record.Student_Name : "No Name";
    }
  }, {
    title: "Dropout Date",
    dataIndex: 'Date',
    key: 'Date',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Date');
    }
  }, {
    title: 'Status',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, record) {
      return /*#__PURE__*/_react.default.createElement(_antd.Tag, {
        color: getStatus(record)
      }, record.Want_to_Drop);
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Want_to_Drop');
    }
  }, {
    title: "Whatsapp Number",
    dataIndex: 'WhatsApp_Number',
    key: 'WhatsApp_Number',
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'WhatsApp_Number');
    }
  }];

  var getStatus = function getStatus(record) {
    if (record.Want_to_Drop === 'नहीं') {
      return 'error';
    }

    if (record.Want_to_Drop === 'हाँ') {
      return 'success';
    }

    return '';
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Old Requests",
    style: {
      'fontSize': '5px'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: tableColumns,
    dataSource: tableData,
    rowKey: "index",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          tableData: record
        });
      }
    }
  })));
};

var _default = TableData;
exports.default = _default;